export var SendMessageType;
(function (SendMessageType) {
    SendMessageType["Add"] = "addSelection";
    SendMessageType["Remove"] = "removeSelection";
    SendMessageType["Clear"] = "clear";
})(SendMessageType || (SendMessageType = {}));
//# sourceMappingURL=SendMessage.js.map